import { useEffect, useRef, useState } from "react";
import { Button } from "../components/rumonai";
import { ApiError } from "../lib/api";
import { localInstaller, type LocalRelease } from "./api";

function downloadError(error: unknown): ApiError {
  return error instanceof ApiError ? error : new ApiError("暂时无法下载", "请稍后重试。", null, 0);
}

function downloadNotice(error: ApiError): string {
  if (error.status === 401) return "请先登录，再重试下载。";
  if (error.status === 403) return "当前账号无法下载客户端。";
  return "暂时无法下载，请稍后重试。";
}

export function LocalInstaller() {
  const [attempt, setAttempt] = useState(0);
  const [release, setRelease] = useState<LocalRelease | null>(null);
  const [error, setError] = useState<ApiError | null>(null);
  const [checking, setChecking] = useState(true);
  const [requested, setRequested] = useState(false);
  const frame = useRef<HTMLIFrameElement | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    setChecking(true);
    setError(null);
    setRelease(null);
    setRequested(false);
    if (frame.current) frame.current.src = "about:blank";
    localInstaller.read(controller.signal).then(value => {
      if (!controller.signal.aborted) setRelease(value);
    }).catch(failure => {
      if (!controller.signal.aborted) setError(downloadError(failure));
    }).finally(() => {
      if (!controller.signal.aborted) setChecking(false);
    });
    return () => controller.abort();
  }, [attempt]);

  function saveInstaller() {
    if (!release || requested || !frame.current) return;
    // Attachment bytes go straight to the browser's download manager. A JSON
    // failure loads in this same-origin frame and is rendered in the page below.
    frame.current.src = `/api/hub/local/installer?release_id=${encodeURIComponent(release.release_id)}`;
    setRequested(true);
  }

  function downloadLoaded() {
    if (!requested) return;
    let failure: unknown;
    try {
      const content = frame.current?.contentDocument?.body?.textContent?.trim();
      if (!content) return;
      const body = JSON.parse(content);
      if (body.error?.audience === "owner" && typeof body.error.title === "string"
        && typeof body.error.detail === "string" && (body.error.hint == null || typeof body.error.hint === "string")) {
        failure = new ApiError(body.error.title, body.error.detail, body.error.hint ?? null, 503, false);
      }
    } catch { /* A proxy error is not Owner-facing text. */ }
    setRelease(null);
    setRequested(false);
    setError(downloadError(failure));
  }

  return <div className="agent-local-installer" aria-busy={checking}>
    <iframe ref={frame} title="本机端下载响应" hidden onLoad={downloadLoaded} />
    {error ? <div className="settings-actions">
      <span role="alert" className="settings-row-desc">{downloadNotice(error)}</span>
      <Button variant="secondary" size="small" onClick={() => setAttempt(value => value + 1)}>重试</Button>
    </div> : <>
      <p><Button variant="secondary" disabled={!release || checking || requested} onClick={saveInstaller}>
        下载 Windows 客户端
      </Button></p>
      {checking ? <p role="status">正在检查下载…</p> : null}
      {requested ? <><p role="status">已请求下载，请在浏览器下载列表查看。</p>
        <Button variant="secondary" onClick={() => setAttempt(value => value + 1)}>重试</Button></> : null}
    </>}
  </div>;
}
